export default "__VITE_ASSET__jp199itw__"